<script>
import AdoptionsService from "@/services/adoptions.service";
import ClientService from "@/services/clients.service";
import MoveBackDialog from "@/components/SinglePostAdoptFirm/MoveBackDialog.vue";

export default {
  name: "Problematic",
  components: { MoveBackDialog },
  props: {
    entityId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    loading: false,
    moveBackDialogVisible: false,
    status: 10,
    moveToDocumentVerificationLoading: false,
    markInactiveLoading: false,
    clients: [],
    headers: [
      {
        text: 'Client',
        value: 'client',
        filterable: true
      },
      {
        text: 'EIN',
        value: 'ein',
        filterable: true
      },
      {
        text: 'Legal Name',
        value: 'legal_name',
        filterable: true
      },
      {
        text: 'Date contact initiated',
        value: 'date',
      }
    ],
    selectedClients: []
  }),
  methods: {
    async moveToDocumentVerification() {
      this.moveToDocumentVerificationLoading = true;
      const payload = {
        status: 6
      }

      for (let i = 0; i < this.selectedClients.length; i++) {
        let client = this.selectedClients[i]
        await AdoptionsService.patchAdoption(client.adoption_id, payload)
      }

      this.$store.dispatch('snackbar/showSnackbarMessage',
        {message: 'Moved to document verification', duration: 6000})
      this.moveToDocumentVerificationLoading = false;
      this.selectedClients = []
      await this.getData()
    },
    async markInactive() {
        this.markInactiveLoading = true;
        const payload = {
          active: 0
        }

        for (let i = 0; i < this.selectedClients.length; i++) {
          let client = this.selectedClients[i]
          await ClientService.editClient(client.id, payload)
        }

      await this.$store.dispatch('snackbar/showSnackbarMessage',
        {message: 'Marked as Inactive', duration: 6000})
      this.selectedClients = []
      this.markInactiveLoading = false;
      await this.getData()
    },
    async getData() {
      this.loading = true

      try {
        this.clients = await AdoptionsService.getAdoptionStatus(this.entityId, this.status)
      } finally {
        this.loading = false
      }
    }
  },
  async mounted() {
    await this.getData()
  }
};
</script>

<template>
  <div>
    <MoveBackDialog
      v-if="moveBackDialogVisible"
      @update:visible="event => moveBackDialogVisible = event"
      @success="getData"
      :visible="moveBackDialogVisible"
      :status="status"
      :statusName="`Problematic`"
      :clients="selectedClients"
    />
    <v-row>
      <v-col cols="12" md="10">
        <v-card>
          <v-card-title>
            <div class="d-flex justify-end" style="width: 100%">
              <v-btn color="primary" :disabled="!selectedClients.length" @click="moveBackDialogVisible = true">
                Move Back
              </v-btn>
            </div>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="clients"
              show-select
              v-model="selectedClients"
              :loading="loading"
              disable-pagination
              hide-default-footer
            />
          </v-card-text>
          <v-card-actions>
            <div class="d-flex justify-space-between" style="width: 100%">
              <v-btn color="primary" :loading="moveToDocumentVerificationLoading" @click="moveToDocumentVerification" :disabled="!selectedClients.length">Move to document verification</v-btn>
              <v-btn color="primary" :loading="markInactiveLoading" @click="markInactive" :disabled="!selectedClients.length">Mark Inactive</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>